import { useMutation } from '@tanstack/react-query';

import { USER_QUERY_KEY } from 'src/features/auth/utils';
import { type MutationConfig, queryClient } from 'src/lib/react-query';
import { storage } from 'src/utils/storage';

type ActionFnType = () => Promise<null>;

// Deletes the token from the storage and redirects to the login screen.
interface UseMutationOptions extends MutationConfig<ActionFnType> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn: async () => {
            storage.clear();
            return null;
        },
        ...options,
        onSuccess: (user, ...rest) => {
            queryClient.setQueryData([USER_QUERY_KEY], null);
            options?.onSuccess?.(user, ...rest);
        },
    });

export { useMutationHook as useLogout };
